import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { AUTH_LOCAL_STORAGE } from '@/constants/localStorageKeyConstants';
import cryptoHelper from '@/utils/crypto';
import rootReducer from './rootReducer';

let middleware = [thunk];

let configStore = applyMiddleware(...middleware);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === 'development') {
  middleware = [...middleware];
  configStore = composeEnhancers(applyMiddleware(...middleware));
}
const authStore = window.localStorage.getItem(AUTH_LOCAL_STORAGE);

// const authStore = CookieManager.getCookie(authLocalStorage);
const initialState = authStore ? { auth: cryptoHelper.decrypt(authStore) } : {};
const store = createStore(rootReducer, initialState, configStore);

export default store;
